import { values, keyBy, merge } from 'lodash-es';

const mergeCollectionsBy = (
  arr1: any[] | undefined,
  arr2: any[] | undefined,
  by: string,
) => (
  values(
    merge(
      keyBy(arr1, by),
      keyBy(arr2, by),
    ),
  )
);

export default mergeCollectionsBy;
